function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { EditorState } from 'draft-js';

var mergeBlockDataByKey = function mergeBlockDataByKey(editorState, blockKey, data) {
  var content = editorState.getCurrentContent();
  var updatedBlock = content.getBlockForKey(blockKey).mergeIn(['data'], data);
  var blockMap = content.getBlockMap().merge(_defineProperty({}, blockKey, updatedBlock));
  return EditorState.push(editorState, content.merge({
    blockMap: blockMap
  }), 'change-block-data');
};

export default mergeBlockDataByKey;